import { useState } from 'react'
import { Button, Caution, Field, Modal } from '@/ui'
import { S } from './strings'
import styles from './CondoView.module.css'

export interface ContactDraft {
  id?: number
  name: string
  role: string
  phone: string
}

interface ContactModalProps {
  initial: ContactDraft
  pending: boolean
  error: boolean
  onClose: () => void
  onSave: (draft: ContactDraft) => void
}

export function ContactModal({ initial, pending, error, onClose, onSave }: ContactModalProps) {
  const [d, setD] = useState(initial)
  const editing = d.id !== undefined
  const set = (k: 'name' | 'role' | 'phone') => (v: string) => setD((s) => ({ ...s, [k]: v }))
  return (
    <Modal
      title={editing ? S.contactEditTitle : S.contactAddTitle}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {S.cancel}
          </Button>
          <Button
            icon="check"
            disabled={!d.name.trim() || !d.phone.trim()}
            loading={pending}
            onClick={() =>
              onSave({ ...d, name: d.name.trim(), role: d.role.trim(), phone: d.phone.trim() })
            }
          >
            {editing ? S.contactSave : S.addContact}
          </Button>
        </>
      }
    >
      <Field
        label={S.contactName}
        value={d.name}
        onChange={set('name')}
        placeholder={S.contactNamePlaceholder}
        autoFocus
      />
      <Field
        label={S.contactRole}
        value={d.role}
        onChange={set('role')}
        placeholder={S.contactRolePlaceholder}
      />
      <Field
        label={S.contactPhone}
        value={d.phone}
        onChange={set('phone')}
        placeholder={S.contactPhonePlaceholder}
      />
      <Caution icon="shield">{S.contactNote}</Caution>
      {error && (
        <p role="alert" className={styles.error}>
          {S.genericError}
        </p>
      )}
    </Modal>
  )
}
